import { EntityIdType } from '@angular-ru/cdk/entity'
import { Observable } from 'rxjs'
import { BaseEntityCollectionRepository } from './base-entity-collection-repository'
import { ExtendedEntityCollectionRepositoryOptions } from './extended-entity-collection-repository-options'

export abstract class EntityCollectionRepository<
  V,
  P,
  K extends number | string = EntityIdType,
  C extends ExtendedEntityCollectionRepositoryOptions = ExtendedEntityCollectionRepositoryOptions
> extends BaseEntityCollectionRepository<V, K, C> {
  protected constructor() {
    super()
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public query(payload: P): any {}

  /** We want a fetch implementation */
  public abstract fetch(payload: P): Observable<V[]>
}
